import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';

import { ChannelForm } from '../../components/ChannelForm/ChannelForm';
import { useCloseFormPopup } from '../../hooks/useCloseFormPopup';
import {
  useEditChannelPopupPresenter,
  IEditChannelPopupPresenterParams,
} from './EditChannelPopup.presenter';

type IEditChannelProps = IEditChannelPopupPresenterParams;

export const EditChannelPopup: FC<ICommonPopupsProps<IEditChannelProps>> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useEditChannelPopupPresenter(props);
  const closeForm = useCloseFormPopup(props, t('cancel_channel_creation_alert'));

  return (
    <Popup
      isOpened
      onClose={closeForm.closePopup}
    >
      <ChannelForm
        title={t('channel_edit_screen_title')}
        initialValues={presenter.initialValues}
        avatarTitle={presenter.avatarTitle}
        avatarColor={presenter.avatarColor}
        isEditMode={true}
        onSubmit={presenter.onSubmit}
        onFormStateChange={closeForm.onFormStateChange}
        onClose={closeForm.closePopup}
      />
    </Popup>
  );
});
